import { createTheme } from '@shopify/polaris-viz';

// Polaris Viz drives chart colours through d3-color, which only understands
// hex/rgb/hsl — NOT our oklch() CSS custom properties. So we resolve the brand
// viz palette to hex here (computed once from the OKLCH tokens) and ship light +
// dark theme variants that ChartProvider swaps based on the active app theme.

const VIZ = {
  indigo: '#356ddc', // viz-1 — email
  coral: '#ec5d4b', // viz-2
  emerald: '#00a768', // viz-3 — whatsapp
  pink: '#e97ab2', // viz-4
  amber: '#e19b1b', // viz-5 — push
  cyan: '#00a7be', // viz-6 — sms
  lavender: '#a58de6', // viz-7
  graphite: '#66616d', // viz-8
} as const;

const SERIES_COLORS = [VIZ.indigo, VIZ.emerald, VIZ.amber, VIZ.cyan, VIZ.coral, VIZ.lavender, VIZ.pink, VIZ.graphite];

// Channel → brand colour, consistent with ChannelMono / channel tokens.
export const CHANNEL_CHART_COLOR: Record<string, string> = {
  email: VIZ.indigo,
  push: VIZ.amber,
  whatsapp: VIZ.emerald,
  sms: VIZ.cyan,
};

function buildTheme(mode: 'light' | 'dark') {
  const dark = mode === 'dark';
  return createTheme({
    chartContainer: { backgroundColor: 'transparent', padding: '10px 4px 4px' },
    grid: { color: dark ? '#25222a' : '#eae7ea', showHorizontalLines: true },
    xAxis: { labelColor: dark ? '#88848c' : '#767379' },
    yAxis: { backgroundColor: 'transparent', labelColor: dark ? '#88848c' : '#767379' },
    seriesColors: { single: VIZ.indigo, all: SERIES_COLORS },
  });
}

export const ENGAGE_THEME_LIGHT = 'EngageLight';
export const ENGAGE_THEME_DARK = 'EngageDark';
export const engageLightTheme = buildTheme('light');
export const engageDarkTheme = buildTheme('dark');
